import { FtlRoutingViewModel } from "../ViewModel/FtlRoutingViewModel";
import { FtlRouteViewModel } from "../ViewModel/FtlRouteViewModel";
import { PuDo } from "../ViewModel/PuDo";
import { RoutingType } from "../ViewModel/RoutingType";

export function setEffectiveSupplierAndDestinationRouting(
  routings: Array<FtlRoutingViewModel>,
  currentRoute: FtlRouteViewModel
) {
  let supplierRouting: FtlRoutingViewModel | undefined;
  let destinationRouting: FtlRoutingViewModel | undefined;

  if (currentRoute.RouteType === "ST-Return") {
    const dorRoutings = routings.filter((routing) => {
      return routing.PuDoType === PuDo.DO_R;
    });
    [destinationRouting] = routings.filter((routing) => {
      return routing.PuDoType === PuDo.PU_R && routing.RoutingType !== RoutingType.Checkpoint;
    });
    supplierRouting = dorRoutings[dorRoutings.length - 1];
  } else {
    const puiRoutings = routings.filter((routing) => {
      return routing.PuDoType === PuDo.PU_I;
    });
    const doiRoutings = routings.filter((routing) => {
      return routing.PuDoType === PuDo.DO_I;
    });
    const purRoutings = routings.filter((routing) => {
      return routing.PuDoType === PuDo.PU_R;
    });
    const dorRoutings = routings.filter((routing) => {
      return routing.PuDoType === PuDo.DO_R;
    });

    // Inbound & Roundtrip
    if (
      (puiRoutings.length > 0 &&
        doiRoutings.length > 0 &&
        purRoutings.length > 0 &&
        dorRoutings.length > 0) ||
      (puiRoutings.length > 0 &&
        doiRoutings.length > 0 &&
        purRoutings.length === 0 &&
        dorRoutings.length === 0)
    ) {
      // eslint-disable-next-line prefer-destructuring
      supplierRouting = puiRoutings[0];
      destinationRouting = doiRoutings[doiRoutings.length - 1];
    }
    // Return
    else if (
      purRoutings.length > 0 &&
      dorRoutings.length > 0 &&
      puiRoutings.length === 0 &&
      doiRoutings.length === 0
    ) {
      supplierRouting = dorRoutings[dorRoutings.length - 1];
      // eslint-disable-next-line prefer-destructuring
      destinationRouting = purRoutings[0];
    } else {
      supplierRouting = undefined;
      destinationRouting = undefined;
    }
  }
  return {
    supplierRouting,
    destinationRouting,
  };
}
